import { CircularProgress, Typography } from "@mui/material";
import { Box } from "@mui/system";
import * as React from "react";

const LoadingScreen = () => {
  return <CircularProgress></CircularProgress>;
};

export default LoadingScreen;
